import React, { useState } from 'react';
import { Table, Checkbox } from 'semantic-ui-react';
import RiskRadioButtonLikelihood from './RiskRadiobuttonLikelihood';

type Props = {
  label: string;
  likelihoodValue?: string;
  likelihoodSetter?: (likelihoodValue: string) => void;
  ignitionValue?: string;
  ignitionSetter?: (ignitionValue: string) => void;
  name: string;
  otherTable?: boolean;
  setOtherTable?: (disabled: boolean) => void;
  disabled?: boolean;
  setDisabled?: (val: boolean) => void;
  disabledComponent?: boolean;
};

const TableRowWithRadioButton = ({
  label,
  likelihoodValue,
  likelihoodSetter,
  ignitionValue,
  ignitionSetter,
  name,
  otherTable,
  setOtherTable,
  disabled,
  setDisabled,
  disabledComponent,
}: Props) => {
  const onOther = () => {
    if (setOtherTable && setDisabled) {
      setOtherTable(!otherTable);
      setDisabled(!disabled);
    }
  };

  return (
    <>
      <Table.Row>
        <Table.Cell>
          <div className="riskAssessmentTableOther">
            {name == 'other' && (
              <Checkbox checked={otherTable} onClick={onOther} disabled={disabledComponent} />
            )}
            {label}
          </div>
        </Table.Cell>
        <Table.Cell>
          <RiskRadioButtonLikelihood
            value={likelihoodValue}
            setValue={likelihoodSetter}
            name={`${name}Likelihood`}
            disabled={name == 'other' ? disabled : disabledComponent}
          />
        </Table.Cell>
        <Table.Cell>
          <RiskRadioButtonLikelihood
            value={ignitionValue}
            setValue={ignitionSetter}
            name={`${name}Ignition`}
            disabled={name == 'other' ? disabled : disabledComponent}
          />
        </Table.Cell>
      </Table.Row>
    </>
  );
};

export default TableRowWithRadioButton;
